import Default from '../Pages/DashBoard/Default/Default';
import BranchAdd from '../Pages/DashboardQeza/Branch/BranchAdd';
import BranchDetailAdmin from '../Pages/DashboardQeza/Branch/BranchDetailAdmin';
import Order from '../Pages/DashboardQeza/Order/Order';
import Treatment from '../Pages/DashboardQeza/Treatment/Treatment';
import TreatmentAdd from '../Pages/DashboardQeza/Treatment/TreatmentAdd';

export const adminRoutes = [
    { path: `${process.env.PUBLIC_URL}/dashboard/`, Component: <Default /> },
    { path: `${process.env.PUBLIC_URL}/clinics/branch/edit/:id`, Component: <BranchAdd /> },
    { path: `${process.env.PUBLIC_URL}/clinics`, Component: <BranchDetailAdmin /> },
    { path: `${process.env.PUBLIC_URL}/treatments/`, Component: <Treatment /> },
    { path: `${process.env.PUBLIC_URL}/treatment/add/`, Component: <TreatmentAdd /> },
    { path: `${process.env.PUBLIC_URL}/treatment/edit/:id`, Component: <TreatmentAdd /> },
    { path: `${process.env.PUBLIC_URL}/doctors`, Component: <BranchDetailAdmin /> },
    { path: `${process.env.PUBLIC_URL}/settings`, Component: <BranchDetailAdmin /> },
    { path: `${process.env.PUBLIC_URL}/orders/`, Component: <Order /> },
];